import { render, staticRenderFns } from "./ProductsTableListEditPrices.vue?vue&type=template&id=068db0ff&"
import script from "./ProductsTableListEditPrices.vue?vue&type=script&lang=js&"
export * from "./ProductsTableListEditPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports